import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-semibold" }
const _hoisted_2 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_3 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_Entries = _resolveComponent("Entries")!

  return (_openBlock(), _createBlock(_component_Entries, {
    title: _ctx.$t('quality_presets'),
    "href-prefix": "quality-presets"
  }, {
    tables: _withCtx(() => [
      _createVNode(_component_EntriesDataTable, {
        entries: _ctx.qualityPresets,
        "entries-handler": _ctx.fetchQualityPresets,
        "href-prefix": "quality-presets"
      }, {
        columns: _withCtx(() => [
          _createVNode(_component_PrimeVueColumn, {
            field: "id",
            header: "ID",
            sortable: ""
          }),
          (_ctx.activeUser.isSuperAdmin())
            ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                key: 0,
                field: "project_id",
                header: _ctx.$t('project'),
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.project.name), 1)
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_PrimeVueColumn, {
            field: "name",
            header: _ctx.$t('name'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              (data.is_builtin)
                ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                    key: 0,
                    class: "mr-2",
                    value: _ctx.$t('is_builtin')
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_1, _toDisplayString(data.name), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "updated_at",
            header: _ctx.$t('updated_at'),
            sortable: ""
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["entries", "entries-handler"])
    ]),
    filters: _withCtx(() => [
      (_ctx.activeUser.isSuperAdmin())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_FieldDropdown, {
              modelValue: _ctx.qualityPresetsFilters.project_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.qualityPresetsFilters.project_id) = $event)),
              modelModifiers: { number: true },
              label: _ctx.$t('project'),
              loading: _ctx.projectsLoading,
              "show-clear": true,
              options: _ctx.projects.data,
              "option-value": "id",
              "option-label": "name",
              "option-label-translate": false
            }, null, 8, ["modelValue", "label", "loading", "options"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FieldText, {
          modelValue: _ctx.qualityPresetsFilters.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.qualityPresetsFilters.name) = $event)),
          modelModifiers: { trim: true },
          label: _ctx.$t('name')
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}